import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { AuctionStatus, BalanceQuery, config, AuctionItem, AUCTION_STATE, AUCTION_TEXT_COLOR, LOYALTY_STATUS } from '@fgb/core';
import { DateTime } from 'luxon';
import { Subscription } from 'rxjs';

@Component({
  selector: 'fgbcl-auction-panel',
  templateUrl: './auction-panel.component.html',
  styleUrls: ['./auction-panel.component.scss'],
})
export class AuctionPanelComponent implements OnInit, OnDestroy {
  @Input() auctionItem: AuctionItem;
  @Input() ignoreLink: boolean = false;
  @Input() isPreview: boolean = false;
  @Input() featuredIcon: string = 'star';
  public auctionStatus = AuctionStatus;
  loyaltyPointsCard: number;
  loyaltyPointsSub: Subscription;
  statusText: string;
  theme: string;
  allowBids: boolean;
  currentValue: number;
  endDate: Date | string;
  isWinning: boolean;
  isComingSoon: boolean;
  config: any = config;
  stockAvailableState: string;
  textColor: string;
  AUCTION_STATE = AUCTION_STATE;
  state = LOYALTY_STATUS;
  constructor(private balanceQuery: BalanceQuery) {}
  ngOnInit() {
    if (!this.isPreview) {
      this.loyaltyPointsSub = this.balanceQuery.selectPurse(this.config.purseConfig.virtualLoyalty).subscribe((bal) => {
        this.loyaltyPointsCard = bal ?? 0;
      });

      const requestTime = DateTime.fromISO(this.auctionItem.RequestTime as string, { zone: 'utc' });
      const startDate = DateTime.fromISO(this.auctionItem?.StartDate as string, { zone: 'utc' });
      this.isComingSoon = this.auctionItem.ComingSoon && startDate > requestTime;
      this.isWinning = this.auctionItem.IsWinning === 0 ? false : true;
      this.currentValue = this.auctionItem.CurrentValue;
      this.endDate = this.auctionItem.EndDate;

      this._updateStatus();
      this.getStockAvailableState();
    }
  }

  ngOnDestroy() {
    if (this.loyaltyPointsSub) {
      this.loyaltyPointsSub.unsubscribe();
    }
  }

  private _updateStatus() {
    this.theme = 'disabled';
    if (this.auctionItem.ComingSoon && this.isComingSoon) {
      this.statusText = AUCTION_STATE.COMING_SOON;
      this.theme = 'coming-soon';
    } else if (
      (!this.isWinning && this.auctionItem.CurrentValue > this.loyaltyPointsCard) ||
      this.auctionItem.BidIncrement > this.loyaltyPointsCard
    ) {
      this.statusText = AUCTION_STATE.NOT_ENOUGH_POINT;
      this.theme = 'not-enough-points';
    } else {
      this.statusText = '';
      this.allowBids = true;
      this.theme = 'auction';
    }
  }

  getStockAvailableState() {
    [this.stockAvailableState, this.textColor] = this.handleStockAvailable(this.auctionItem);
  }

  private handleStockAvailable(auctionItem: AuctionItem) {
    if (!auctionItem) return ['', this.theme];

    // New Stock

    const startDate = DateTime.fromISO(auctionItem.StartDate as string, { zone: 'utc' });

    const now = DateTime.utc();
    const days = now.diff(startDate, 'days').days;

    const threeDays = 3;
    if (days <= threeDays) return [AUCTION_STATE.NEW, AUCTION_TEXT_COLOR.NEW];

    // Stock Favourite
    if (auctionItem.Favourite) return [AUCTION_STATE.FEATURED, AUCTION_TEXT_COLOR.GREEN];
    else return ['', this.theme];
  }
}
